import axios from "axios";
import utils from "../utils";

const getAllClass = async () => {
  try {
    const response = await axios.get(`${utils.baseUrl}/classes`);
  
    if(response.status !== 200) {
      return {
        data: null,
        message: response.data.message
      }
    }
  
    return {
      data: response.data,
      message: response.data.message
    }
  } catch (error) {
    console.error(error)
  }
}


const deleteOneClass = async (class_id) => {
  try {
    const response = await axios.delete(`${utils.baseUrl}/classes/${class_id}`);

    return {
      message: response.data.message,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message
    }
  }
}

const updateOneClass = async (class_id, data) => {
  try {
    const response = await axios.patch(`${utils.baseUrl}/classes/${class_id}`, data);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const createOneClass = async (data) => {
  try {
    const response = await axios.post(`${utils.baseUrl}/classes`, data);
    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const classService = {
  getAllClass,
  deleteOneClass,
  updateOneClass,
  createOneClass
}

export default classService;